(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_dropdown-filter"] && !Shopify.designMode) return;
  try {
    class DropdownFilterBlock extends HTMLElement {

    constructor() {
      super();

      this.vendors = [];
      this.models = [];

      this.manufacturerSelect = null;
      this.modelSelect = null;
      this.submitButton = null;

      this.resultsUrl = "";
    }


    connectedCallback() {

      const dataScript = this.querySelector(
        "[data-dropdown-filter-data]"
      );

      this.manufacturerSelect = this.querySelector(
        "[data-dropdown-filter-manufacturer]"
      );

      this.modelSelect = this.querySelector(
        "[data-dropdown-filter-model]"
      );

      this.submitButton = this.querySelector(
        "[data-dropdown-filter-submit]"
      );

      this.resultsUrl =
        this.dataset.resultsUrl || "/collections/all";


      if (
        !dataScript ||
        !this.manufacturerSelect ||
        !this.modelSelect ||
        !this.submitButton
      ) {
        return;
      }


      try {

        const data = JSON.parse(
          dataScript.textContent
        );

        this.vendors = Array.isArray(data.vendors)
          ? data.vendors.filter((item) => {
              return (
                item &&
                item.value
              );
            })
          : [];

        this.models = Array.isArray(data.models)
          ? data.models.filter((item) => {
              return (
                item.manufacturer &&
                item.model &&
                item.gid
              );
            })
          : [];

      } catch (error) {

        console.error(
          "Suodatinseppo filter data error:",
          error
        );

        return;

      }


      this.populateManufacturers();


      this.manufacturerSelect.addEventListener(
        "change",
        this.onManufacturerChange.bind(this)
      );


      this.modelSelect.addEventListener(
        "change",
        this.onModelChange.bind(this)
      );


      this.submitButton.addEventListener(
        "click",
        this.onSubmit.bind(this)
      );

    }


    populateManufacturers() {

      const placeholder =
        this.manufacturerSelect
          .options[0]
          ?.textContent || "";


      const seenKeys = new Set();

      const vendors = this.vendors
        .filter((item) => {

          const key =
            `${item.value}::${item.label || ""}`;

          if (seenKeys.has(key)) {
            return false;
          }

          seenKeys.add(key);

          return true;

        })
        .sort((a, b) =>
          (a.label || a.value).localeCompare(
            b.label || b.value,
            "fi",
            {
              sensitivity: "base"
            }
          )
        );


      this.manufacturerSelect.innerHTML = "";

      this.manufacturerSelect.append(
        new Option(
          placeholder,
          ""
        )
      );


      vendors.forEach((vendor) => {

        this.manufacturerSelect.append(
          new Option(
            vendor.label || vendor.value,
            vendor.value
          )
        );

      });


      if (vendors.length) {
        this.manufacturerSelect.disabled = false;
      }

    }


    onManufacturerChange() {

      const manufacturer =
        this.manufacturerSelect.value;


      this.resetModelSelect();

      this.submitButton.disabled = true;


      if (!manufacturer) {
        return;
      }


      const normalizedManufacturer =
        manufacturer
          .trim()
          .toLocaleLowerCase("fi");


      const modelsForManufacturer =
        this.models
          .filter((item) => {

            const itemManufacturer =
              String(
                item.manufacturer || ""
              )
                .trim()
                .toLocaleLowerCase("fi");


            return (
              itemManufacturer ===
              normalizedManufacturer
            );

          })
          .sort((a, b) =>
            a.model.localeCompare(
              b.model,
              "fi",
              {
                numeric: true,
                sensitivity: "base"
              }
            )
          );


      const seen = new Set();


      modelsForManufacturer.forEach(
        (item) => {

          const key =
            `${item.model}::${item.gid}`;

          if (seen.has(key)) {
            return;
          }

          seen.add(key);


          const option = new Option(
            item.model,
            item.gid
          );

          this.modelSelect.append(option);

        }
      );


      if (this.modelSelect.options.length > 1) {
        this.modelSelect.disabled = false;
      }

    }


    onModelChange() {

      this.submitButton.disabled =
        !(
          this.manufacturerSelect.value &&
          this.modelSelect.value
        );

    }


    resetModelSelect() {

      const placeholder =
        this.modelSelect
          .options[0]
          ?.textContent || "";


      this.modelSelect.innerHTML = "";

      this.modelSelect.append(
        new Option(
          placeholder,
          ""
        )
      );


      this.modelSelect.disabled = true;

    }


    buildTargetUrl() {

      const manufacturer =
        this.manufacturerSelect.value;

      const modelGid =
        this.modelSelect.value;


      if (
        !manufacturer ||
        !modelGid
      ) {
        return "";
      }


      const selectedModel =
        this.models.find((item) => {
          return item.gid === modelGid;
        });


      if (!selectedModel) {
        return "";
      }


      const products =
        Array.isArray(selectedModel.products)
          ? selectedModel.products.filter((product) => {
              return (
                product &&
                product.url
              );
            })
          : [];


      /*
       * Jos mallilla on täsmälleen
       * yksi yhteensopiva tuote,
       * mennään suoraan tuotesivulle.
       */
      if (products.length === 1) {
        return products[0].url;
      }


      /*
       * Jos tuotteita ei ole tai niitä
       * on enemmän kuin yksi,
       * näytetään yhteensopivat tuotteet
       * suodatetulla kokoelmasivulla.
       */
      const targetUrl = new URL(
        this.resultsUrl,
        window.location.origin
      );


      targetUrl.searchParams.set(
        "filter.p.vendor",
        manufacturer
      );


      targetUrl.searchParams.set(
        "filter.p.m.custom.compatible_models",
        modelGid
      );


      return targetUrl.toString();

    }


    onSubmit() {

      const targetUrl =
        this.buildTargetUrl();


      if (!targetUrl) {
        return;
      }


      if (
        this.submitButton.hasAttribute(
          "data-open-in-new-tab"
        )
      ) {

        window.open(
          targetUrl,
          "_blank",
          "noopener,noreferrer"
        );

      } else {

        window.location.href =
          targetUrl;

      }

    }

  }


  if (
    !customElements.get(
      "dropdown-filter-block"
    )
  ) {

    customElements.define(
      "dropdown-filter-block",
      DropdownFilterBlock
    );

  }
  } catch(e) { console.error(e); }
})();

})();
